"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var FormRow_1 = require("../../components/FormRow");
/**
 * Dies sind die standard propTypes der Enhanced Komponente, falls keine eigenen
 * propTypes definiert werden.
 * Diese können in der Enhanced Komponente bequem erweitert werden:
 *
 * ```typescript
 * const enhancedPropTypes = {
 *  ...withinFormRowPropTypes,
 *
 *  myCustomProp: PropTypes.string
 * }
 * ```
 */
exports.withFormRowWrapperPropTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    error: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
        PropTypes.element
    ]),
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};
/**
 * Diese Funktion spaltet die Properties zwischen der `FormRow`
 * und der zu erweiternden Komponente auf. Sie kann entweder
 * selbst neu implementiert werden oder wie im folgenden Beispiel
 * gewrappt werden:
 *
 * ```typescript
 * // Diese Split funktion sorgt dafür, dass keine `children` an die Komponente
 * // weitergereicht wird und die Property `className` um eine weitere Klasse
 * // erweitert wird
 * const enhancedSplitProps = (props: EnhancedComponentProps):
 *  WithFormRowWrapperPropsSplitted<WrappedComponentProps> => {
 *  const { children, className, ...other } = props;
 *
 *  return withFormRowWrapperSplitProps<EnhancedComponentProps, WrappedComponentProps>({
 *    className: classNames('my-custom-class', className),
 *    ...other
 *  });
 * }
 * ```
 * @param props Die Properties der Komponente werden als hier als Parameter in die Funktion gereicht
 */
function withFormRowWrapperSplitProps(props) {
    var _a = props, label = _a.label, description = _a.description, tooltip = _a.tooltip, boundary = _a.boundary, error = _a.error, className = _a.className, other = __rest(_a, ["label", "description", "tooltip", "boundary", "error", "className"]);
    return {
        formRowProps: {
            label: label,
            description: description,
            tooltip: tooltip,
            boundary: boundary,
            error: typeof error === 'boolean' ? undefined : error,
            className: className
        },
        componentProps: __assign({}, other, { error: Boolean(error) })
    };
}
exports.withFormRowWrapperSplitProps = withFormRowWrapperSplitProps;
/**
 * Diese Funktion wrapped eine Komponente in eine FormRow. Als Parameter
 * werden die propTypes, defaultProps und eine Splitter-Funktion für die
 * Properties (siehe Dokumentation der `withinFormRowSplitProps`-Funktion)
 * übergeben.
 *
 * Beim Export einer solchen EnhancedComponent wird empfohlen, vorher explizit
 * den `displayName` zu setzen:
 *
 * ```typescript
 * export const MyCustomRow = createComponentWithinFormRow(
 *  propTypes,
 *  defaultProps
 * )(Input);
 * MyCustomRow.displayName = 'MyCustomRow';
 *
 * export default MyCustomRow;
 * ```
 *
 * @param propTypes propTypes of the `EnhancedComponent`
 * @param defaultProps defaultProps of the `EnhancedComponent`
 * @param splitProps Function to split props up to pass onto the `FormRow` or the `EnhancedComponent`
 */
function withFormRowWrapper(propTypes, defaultProps, splitProps) {
    return function createWithFormRowWrapper(ComponentToEnhance) {
        var _a;
        return _a = /** @class */ (function (_super) {
                __extends(ComponentWithinFormRow, _super);
                function ComponentWithinFormRow() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.displayName = "ComponentWithFormRowWrapper::" + (ComponentToEnhance.displayName ||
                        ComponentToEnhance.name);
                    return _this;
                }
                ComponentWithinFormRow.prototype.render = function () {
                    var _a = splitProps(this.props), formRowProps = _a.formRowProps, componentProps = _a.componentProps;
                    return (React.createElement(FormRow_1.default, __assign({}, formRowProps),
                        React.createElement(ComponentToEnhance, __assign({}, componentProps))));
                };
                return ComponentWithinFormRow;
            }(React.Component)),
            _a.propTypes = propTypes,
            _a.defaultProps = defaultProps,
            _a;
    };
}
exports.withFormRowWrapper = withFormRowWrapper;
exports.default = withFormRowWrapper;
//# sourceMappingURL=ComponentWithFormRowWrapper.js.map
